module.exports = __webpack_public_path__ + "static/media/transpose_icon.4a8c92a4.svg";